import React from 'react';
import { motion } from 'framer-motion';
import { FlowLine } from './FlowLine';
const situations = ['Un jour, vous enseignez à des débutantes.', 'Le lendemain, vous travaillez avec un groupe plus avancé.', 'Une élève bloque sur une pirouette.', 'Une autre manque de contrôle dans ses réceptions.', 'Parfois, vous avez beaucoup de temps pour préparer.', 'Parfois, seulement quelques minutes.'];
export function WhyDifferent() {
  return <section className="border-y border-brand-line bg-white px-4 py-20 sm:py-28" data-id="element-296" data-mp="mz77l8nj1rxh">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-297" data-mp="r2dbi9n6370s">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-298" data-mp="d22kn6luxsfm">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-brand-deep" data-id="element-299" data-mp="2xrrz3iinfc7s">
            Pourquoi ce système est différent
          </p>
          <h2 className="mt-3 text-3xl font-semibold leading-tight text-brand-ink sm:text-4xl" data-id="element-300" data-mp="3kpybo2zpq1wm">
            Vous n’avez pas besoin de lire de longues pages avant de pouvoir
            utiliser le contenu.
          </h2>
          <p className="mt-5 text-base leading-7 text-brand-muted" data-id="element-301" data-mp="3upp6k5s6qix8">
            Le système principal est conçu pour être entièrement visuel.
          </p>
          <FlowLine className="mt-6" label="Une page peut vous montrer rapidement :" steps={['Position', 'Progression', 'Erreur', 'Correction', 'Exercice']} data-id="element-302" data-mp="3prxdh8ft0qrg" />
          <p className="mt-6 text-base font-medium leading-7 text-brand-ink" data-id="element-303" data-mp="h9riwriu5p2m">
            Vous passez moins de temps à interpréter le matériel et davantage
            de temps à l’utiliser avec vos élèves.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl bg-brand-blush p-6 sm:p-9" data-id="element-304" data-mp="r908772rafin">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-brand-deep" data-id="element-305" data-mp="yc6ui6x1dfwa">
            Pensé pour le travail réel du professeur
          </p>
          <ul className="mt-6 divide-y divide-brand-rose/30" data-id="element-306" data-mp="180yftw7ld1y8">
            {situations.map(situation => <li key={situation} className="py-3 font-display text-lg italic text-brand-ink" data-id="element-307" data-mp="1d0bdlc003tfl">
                {situation}
              </li>)}
          </ul>
          <p className="mt-6 text-sm leading-6 text-brand-muted" data-id="element-308" data-mp="1m0ga2r3np7ez">
            Professeur de Danse Classique Pro a été organisé pour vous donner
            des ressources utiles dans chacune de ces situations.
          </p>
        </motion.div>
      </div>
    </section>;
}